import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  FormsModule
} from '@angular/forms';

import {
  QuartoService,
  Quarto,
  Tarifas
} from '../../../service/quarto.service';

import Swal from 'sweetalert2';


@Component({
  selector: 'app-quartos',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './quartos.component.html',

  styleUrls: [
    './quartos.component.css'
  ]
})
export class QuartosComponent
  implements OnInit {


  quartos: Quarto[] = [];

  carregando = false;

  salvando = false;

  modalAberto = false;


  diasSemana = [
    {
      chave: 'SEGUNDA',
      nome: 'Segunda'
    },
    {
      chave: 'TERCA',
      nome: 'Terça'
    },
    {
      chave: 'QUARTA',
      nome: 'Quarta'
    },
    {
      chave: 'QUINTA',
      nome: 'Quinta'
    },
    {
      chave: 'SEXTA',
      nome: 'Sexta'
    },
    {
      chave: 'SABADO',
      nome: 'Sábado'
    },
    {
      chave: 'DOMINGO',
      nome: 'Domingo'
    }
  ];


  quartoEditando: Quarto = {

    id: 0,

    nome: '',

    descricao: '',

    capacidade: 1,

    tarifas: {},

    tarifasData: {},

    valorCrianca: 0,

    valorAnimal: 0,

    status: 'DISPONIVEL'

  };


  constructor(
    private quartoService: QuartoService,
    private cdr: ChangeDetectorRef
  ) {}


  ngOnInit(): void {

    this.carregarQuartos();

  }


  carregarQuartos(): void {

    this.carregando = true;

    this.quartoService
      .listar()
      .subscribe({

        next: (quartos) => {

          this.quartos = [...quartos];

          this.carregando = false;

          this.cdr.detectChanges();

        },

        error: () => {

          this.carregando = false;

          this.cdr.detectChanges();

          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível carregar as acomodações.'
          });

        }

      });

  }


  abrirModalEdicao(
    quarto: Quarto
  ): void {

    this.quartoEditando = {

      ...quarto,

      valorCrianca:
        quarto.valorCrianca ?? 0,

      valorAnimal:
        quarto.valorAnimal ?? 0,

      tarifas:
        this.copiarTarifas(
          quarto.tarifas
        )

    };

    this.inicializarTarifas();

    this.modalAberto = true;

    this.cdr.detectChanges();

  }


  fecharModal(): void {

    if (this.salvando) {
      return;
    }

    this.modalAberto = false;

  }


  inicializarTarifas(): void {

    if (!this.quartoEditando.tarifas) {

      this.quartoEditando.tarifas = {};

    }


    for (const dia of this.diasSemana) {

      if (
        !this.quartoEditando.tarifas[dia.chave]
      ) {

        this.quartoEditando.tarifas[dia.chave] = {};

      }


      for (
        let quantidade = 1;
        quantidade <= this.quartoEditando.capacidade;
        quantidade++
      ) {

        if (
          this.quartoEditando
            .tarifas[dia.chave][quantidade] === undefined
        ) {

          this.quartoEditando
            .tarifas[dia.chave][quantidade] = 0;

        }

      }

    }

  }


  copiarTarifas(
    tarifas: Tarifas
  ): Tarifas {

    const copia: Tarifas = {};

    if (!tarifas) {
      return copia;
    }


    for (
      const dia of Object.keys(tarifas)
      ) {

      copia[dia] = {
        ...tarifas[dia]
      };

    }


    return copia;

  }


  salvarQuarto(): void {

    if (!this.quartoEditando.id) {
      return;
    }


    this.inicializarTarifas();


    /*
     * VALIDA TARIFAS
     */

    for (const dia of this.diasSemana) {

      for (
        let quantidade = 1;
        quantidade <= this.quartoEditando.capacidade;
        quantidade++
      ) {

        const valor =
          this.quartoEditando
            .tarifas[dia.chave][quantidade];


        if (
          valor === null ||
          valor === undefined ||
          valor <= 0
        ) {

          Swal.fire({

            icon: 'warning',

            title: 'Tarifa inválida',

            text:
              `Informe o valor de ${dia.nome} `
              + `para ${quantidade} hóspede(s).`

          });

          return;

        }

      }

    }


    /*
     * VALIDA VALOR DA CRIANÇA
     */

    if (
      this.quartoEditando.valorCrianca === null ||
      this.quartoEditando.valorCrianca === undefined ||
      this.quartoEditando.valorCrianca < 0
    ) {

      Swal.fire({

        icon: 'warning',

        title: 'Valor inválido',

        text:
          'Informe um valor válido para criança.'

      });

      return;

    }


    /*
     * VALIDA VALOR DO ANIMAL
     */

    if (
      this.quartoEditando.valorAnimal === null ||
      this.quartoEditando.valorAnimal === undefined ||
      this.quartoEditando.valorAnimal < 0
    ) {

      Swal.fire({

        icon: 'warning',

        title: 'Valor inválido',

        text:
          'Informe um valor válido para animal.'

      });

      return;

    }


    this.salvando = true;


    this.quartoService
      .atualizar(

        this.quartoEditando.id,

        {

          nome:
          this.quartoEditando.nome,

          descricao:
          this.quartoEditando.descricao,

          capacidade:
          this.quartoEditando.capacidade,

          tarifas:
          this.quartoEditando.tarifas,

          valorCrianca:
          this.quartoEditando.valorCrianca,

          valorAnimal:
          this.quartoEditando.valorAnimal

        }

      )
      .subscribe({

        next: (quartoAtualizado) => {

          const index =
            this.quartos.findIndex(

              quarto =>
                quarto.id ===
                quartoAtualizado.id

            );


          if (index !== -1) {

            this.quartos[index] =
              quartoAtualizado;

          }


          this.salvando = false;

          this.modalAberto = false;

          this.cdr.detectChanges();


          Swal.fire({

            icon: 'success',

            title: 'Alterado!',

            text:
              'Os dados, tarifas e valores adicionais foram atualizados.',

            timer: 1800,

            showConfirmButton: false

          });

        },


        error: () => {

          this.salvando = false;

          this.cdr.detectChanges();

          Swal.fire({

            icon: 'error',

            title: 'Erro',

            text:
              'Não foi possível atualizar o quarto.'

          });

        }

      });

  }


  alternarStatus(
    quarto: Quarto
  ): void {

    const novoStatus:
      'DISPONIVEL' | 'INDISPONIVEL' =

      quarto.status === 'DISPONIVEL'
        ? 'INDISPONIVEL'
        : 'DISPONIVEL';


    this.quartoService
      .alterarStatus(

        quarto.id,

        novoStatus

      )
      .subscribe({

        next: () => {

          quarto.status =
            novoStatus;

          this.cdr.detectChanges();


          Swal.fire({

            icon: 'success',

            title:
              'Status atualizado',

            text:

              novoStatus === 'DISPONIVEL'

                ? 'Quarto disponibilizado.'

                : 'Quarto desativado.',

            timer: 1500,

            showConfirmButton: false

          });

        },


        error: () => {

          Swal.fire({

            icon: 'error',

            title: 'Erro',

            text:
              'Não foi possível alterar o status.'

          });

        }

      });

  }

}
